function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path929",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.465154,228.72464 c 0,5.38974 -9.758892,29.08335 -9.758892,29.08335 0,0 -9.758537,-23.69361 -9.758537,-29.08335 0,-5.38974 4.369152,-9.75889 9.758537,-9.75889 5.390446,0 9.758892,4.36915 9.758892,9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path931",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.042122,230.34248 c 3.811057,3.81106 13.66414,27.46551 13.66414,27.46551 0,0 -23.653749,-9.85343 -27.464807,-13.66449 -3.8110585,-3.81106 -3.8110585,-9.98996 0,-13.80102 3.811058,-3.81106 9.989608,-3.81106 13.800667,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path933",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.623264,248.0491 c 5.389738,0 29.082998,9.75889 29.082998,9.75889 0,0 -23.69326,9.75854 -29.082998,9.75854 -5.3890335,0 -9.75853948,-4.36915 -9.75853948,-9.75854 0,-5.38974 4.36950598,-9.75889 9.75853948,-9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path935",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.241455,271.47214 c 3.811058,-3.81106 27.464807,-13.66415 27.464807,-13.66415 0,0 -9.853083,23.65446 -13.663788,27.46516 -3.811411,3.81071 -9.989961,3.81071 -13.801019,0 -3.8110585,-3.81105 -3.8110585,-9.98996 0,-13.80101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path937",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.947725,286.89099 c 0,-5.38974 9.758537,-29.083 9.758537,-29.083 0,0 9.758892,23.69326 9.758892,29.083 0,5.38974 -4.368446,9.75854 -9.758892,9.75854 -5.389385,0 -9.758537,-4.3688 -9.758537,-9.75854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path939",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.370758,285.27315 c -3.811058,-3.8107 -13.664496,-27.46516 -13.664496,-27.46516 0,0 23.654808,9.85309 27.465867,13.66415 3.811058,3.81105 3.811058,9.98996 0,13.80101 -3.811059,3.81071 -9.990667,3.81071 -13.801371,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path941",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.789614,267.56653 c -5.389737,0 -29.083352,-9.75854 -29.083352,-9.75854 0,0 23.693615,-9.75889 29.083352,-9.75889 5.389388,0 9.758888,4.36915 9.758888,9.75854 0,5.38974 -4.3695,9.75889 -9.758888,9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path943",
    style: {
      fill: "#a9551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.172129,244.1435 c -3.811059,3.81106 -27.465867,13.66449 -27.465867,13.66449 0,0 9.853438,-23.65445 13.664496,-27.46551 3.810704,-3.81106 9.989961,-3.81106 13.801371,0 3.811058,3.81106 3.811058,9.98996 0,13.80102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path945",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.04307,246.82673 c -2.373841,2.4264 -17.198975,8.79545 -17.198975,8.79545 0,0 6.03885,-14.96307 8.412692,-17.38947 2.372432,-2.42605 6.262865,-2.46909 8.689269,-0.096 2.426406,2.37314 2.469446,6.26357 0.09701,8.68998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path947",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.613879,236.37075 c 0.0381,3.39337 -5.941129,18.38007 -5.941129,18.38007 0,0 -6.31049,-14.85053 -6.348238,-18.24425 -0.03739,-3.39337 2.682875,-6.17503 6.07695,-6.21277 3.393371,-0.0377 6.175023,2.68252 6.212417,6.07695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path949",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.72535,238.47189 c 2.426052,2.37278 8.795102,17.19862 8.795102,17.19862 0,0 -14.963069,-6.0392 -17.388769,-8.41234 -2.426759,-2.37348 -2.469797,-6.26356 -0.09631,-8.68962 2.373136,-2.4264 6.263217,-2.46979 8.689976,-0.0967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path951",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.269016,251.90038 c 3.393722,-0.0377 18.380076,5.94183 18.380076,5.94183 0,0 -14.850182,6.30979 -18.244256,6.34753 -3.393723,0.0374 -6.17467,-2.68322 -6.212417,-6.07659 -0.03775,-3.39373 2.682875,-6.17573 6.076597,-6.21277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path953",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.37016,268.78926 c 2.372784,-2.42605 17.198623,-8.79546 17.198623,-8.79546 0,0 -6.03885,14.96307 -8.411988,17.38948 -2.373487,2.42605 -6.263568,2.46874 -8.690326,0.0956 -2.426406,-2.37278 -2.469445,-6.26321 -0.09631,-8.68962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path955",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.798645,279.24559 c -0.03739,-3.39372 5.941838,-18.38042 5.941838,-18.38042 0,0 6.310487,14.85018 6.347529,18.24425 0.0381,3.39372 -2.682875,6.17467 -6.076243,6.21242 -3.394075,0.0381 -6.175375,-2.68217 -6.213124,-6.07625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path957",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.687529,277.14445 c -2.426052,-2.37314 -8.795102,-17.19827 -8.795102,-17.19827 0,0 14.963068,6.0385 17.388768,8.41163 2.426759,2.37314 2.469444,6.26322 0.09631,8.68963 -2.372432,2.42605 -6.263569,2.46979 -8.689975,0.097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path959",
    style: {
      fill: "#f1a156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.143862,263.71561 c -3.393368,0.0378 -18.380427,-5.94184 -18.380427,-5.94184 0,0 14.850534,-6.31013 18.244254,-6.34788 3.393723,-0.0374 6.175023,2.68323 6.212417,6.07695 0.03775,3.39337 -2.682169,6.17538 -6.076244,6.21277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path961",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.719587,241.40594 c -0.04374,2.61761 -4.973812,14.04444 -4.973812,14.04444 0,0 -4.547306,-11.58416 -4.503915,-14.20177 0.04374,-2.61691 2.200627,-4.70359 4.817534,-4.66055 2.61761,0.0437 4.703585,2.20098 4.660193,4.81788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path963",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.653404,242.66571 c 1.819629,1.88101 6.4135,13.44683 6.4135,13.44683 0,0 -11.406716,-4.97522 -13.226344,-6.85659 -1.81998,-1.88171 -1.769886,-4.88173 0.111478,-6.70207 1.881364,-1.81998 4.881739,-1.76988 6.701366,0.11183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path965",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.304566,252.79467 c 2.617611,0.0437 14.044436,4.97381 14.044436,4.97381 0,0 -11.584517,4.54766 -14.201775,4.50427 -2.617258,-0.0437 -4.703233,-2.20063 -4.659841,-4.81789 0.04339,-2.61761 2.199922,-4.70358 4.81718,-4.66019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path967",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.563983,265.86085 c 1.881364,-1.81998 13.447887,-6.41385 13.447887,-6.41385 0,0 -4.975928,11.40707 -6.857645,13.22705 -1.881717,1.81963 -4.88174,1.76953 -6.701367,-0.11148 -1.819981,-1.88136 -1.769886,-4.88209 0.111125,-6.70172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path969",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.693644,274.20934 c 0.04339,-2.61691 4.973814,-14.04373 4.973814,-14.04373 0,0 4.547659,11.58452 4.503912,14.20142 -0.04339,2.61726 -2.200626,4.70323 -4.817885,4.66019 -2.617258,-0.0434 -4.703233,-2.20062 -4.659841,-4.81788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path971",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.75912,272.95063 c -1.819626,-1.88172 -6.413145,-13.44789 -6.413145,-13.44789 0,0 11.407069,4.97558 13.227047,6.85729 1.81963,1.88137 1.769182,4.88174 -0.111828,6.70137 -1.881365,1.82033 -4.881386,1.77059 -6.702074,-0.11077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path973",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.10796,262.82097 c -2.617258,-0.0437 -14.043731,-4.97382 -14.043731,-4.97382 0,0 11.584871,-4.54766 14.201423,-4.50391 2.617258,0.0434 4.703585,2.20027 4.660545,4.81753 -0.04409,2.61691 -2.200978,4.70394 -4.818237,4.6602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path975",
    style: {
      fill: "#a5743c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.848895,249.75478 c -1.881362,1.82034 -13.447183,6.4135 -13.447183,6.4135 0,0 4.97558,-11.40671 6.85659,-13.22669 1.881717,-1.81998 4.882092,-1.76954 6.70207,0.11183 1.81963,1.88101 1.769888,4.88138 -0.111477,6.70136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path977",
    style: {
      fill: "#332717",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.20947,258.43947 c 0,2.75942 -2.236962,4.99639 -4.996391,4.99639 -2.759075,0 -4.996037,-2.23697 -4.996037,-4.99639 0,-2.75908 2.236962,-4.99604 4.996037,-4.99604 2.759429,0 4.996391,2.23696 4.996391,4.99604"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower8);
export default __webpack_public_path__ + "static/media/flower-8.f254063b4906b115ba5187b5d06a0bd7.svg";
export { ForwardRef as ReactComponent };